import { QuestionStatus, SecurityStatus, WebinarContentSummary } from '@core/swagger-client';
import { WebinarStatus } from '@core/types';
import { Chapters, Heading, Polls, Presentation, Security, Survey, Users } from '@core/ui';
import { useTranslation } from 'react-i18next';
import { WebinarDataItem } from '../../atoms';

export const UpNextWebinarData = ({ webinar }: { webinar: WebinarContentSummary }) => {
    const { t } = useTranslation();

    const securityStatusText = {
        [SecurityStatus.NotEnabled]: t('Webinar.Data.Status.NotEnabled'),
        [SecurityStatus.Enabled]: t('Webinar.Data.Status.Enabled')
    };

    const questionnaireStatusText: Record<QuestionStatus, string> = {
        [QuestionStatus.NotEnabled]: t('Webinar.Data.Status.NotEnabled'),
        [QuestionStatus.NotValid]: t('Webinar.Data.Status.NotValid'),
        [QuestionStatus.Enabled]: t('Webinar.Data.Status.Enabled')
    };

    return (
        <div className="bg-white z-1">
            <Heading variant="h4" classNames="-mt-2 mb-2">
                {t('Webinar.Data.Heading')}
            </Heading>
            <div className="webinar-data-wrapper">
                {webinar.status !== WebinarStatus.Ended && (
                    <WebinarDataItem
                        data={webinar.numberOfInterested}
                        icon={<Users />}
                        subject={t('Webinar.Data.Interested')}
                        to="/$webinarId/interested-accounts"
                        params={{ webinarId: webinar.webinarId }}
                        state={{ backTo: 'overview' }}
                    />
                )}
                {((webinar.status === WebinarStatus.Planned && webinar.numberOfOnlineParticipants > 0) || webinar.status === WebinarStatus.Started) && (
                    <WebinarDataItem
                        data={webinar.numberOfOnlineParticipants}
                        icon={<Users />}
                        subject={t('Webinar.Data.Viewers')}
                        to="/$webinarId/live-participants"
                        params={{ webinarId: webinar.webinarId }}
                        state={{ backTo: 'overview' }}
                    />
                )}
                <WebinarDataItem
                    data={webinar.numberOfSlides}
                    icon={<Presentation />}
                    subject={t('Webinar.Data.Slides')}
                    to="/$webinarId/slide-deck"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
                <WebinarDataItem
                    data={webinar.numberOfChapters}
                    icon={<Chapters />}
                    subject={t('Webinar.Data.Chapters')}
                    to="/$webinarId/chapters"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
                <WebinarDataItem
                    data={webinar.numberOfPolls}
                    icon={<Polls />}
                    subject={t('Webinar.Data.Polls')}
                    to="/$webinarId/polls"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
                {/*<WebinarDataItem*/}
                {/*    data='0'*/}
                {/*    icon={<Attachment />}*/}
                {/*    subject={t('Webinar.Data.Attachment')}*/}
                {/*    to="/$webinarId/attachments"*/}
                {/*    params={{ webinarId: webinar.webinarId }}*/}
                {/*/>*/}
                <WebinarDataItem
                    data={questionnaireStatusText[webinar.surveyStatus]}
                    icon={<Survey />}
                    subject={t('Webinar.Data.Survey')}
                    to="/$webinarId/edit-survey"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
                <WebinarDataItem
                    data={questionnaireStatusText[webinar.examStatus]}
                    icon={<Survey />}
                    subject={t('Webinar.Data.Exam')}
                    to="/$webinarId/edit-exam"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
                <WebinarDataItem
                    data={securityStatusText[webinar.securityStatus]}
                    icon={<Security />}
                    subject={t('Webinar.Data.Security')}
                    to="/$webinarId/security"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
            </div>
        </div>
    );
};
